import { rankings, rankItem } from "@tanstack/match-sorter-utils";

export function filterFilesByPath<T extends { path: string }>(
  files: readonly T[],
  query: string,
): T[] {
  const trimmed = query.trim();
  if (trimmed.length === 0) return [...files];
  return files.filter(
    (file) => rankItem(file.path, trimmed, { threshold: rankings.CONTAINS }).passed,
  );
}

export function fileBasename(path: string): string {
  const separatorIndex = path.lastIndexOf("/");
  return separatorIndex >= 0 ? path.slice(separatorIndex + 1) : path;
}
